export default __webpack_public_path__ + "static/media/jcb.6d50376e.png";